import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Создание администратора",
    "confirm-button-text": "Создать",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.createUser
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        placeholder: "Имя пользователя"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.email,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.email) = $event)),
        "is-invalid": _ctx.state_form$.email.$error,
        "validation-errors": _ctx.state_form$.email.$errors,
        class: "mt-2",
        placeholder: "E-mail"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.phone,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.phone) = $event)),
        "is-invalid": _ctx.state_form$.phone.$error,
        "validation-errors": _ctx.state_form$.phone.$errors,
        class: "mt-2",
        placeholder: "Телефон"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.password,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.password) = $event)),
        "is-invalid": _ctx.state_form$.password.$error,
        "validation-errors": _ctx.state_form$.password.$errors,
        class: "mt-2",
        placeholder: "Пароль"
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}